import { useMemo } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

// Single-period PIX vs Cartão split (by paid value), scoped to whatever
// `payments` the caller already fetched for the period — unlike the
// Dashboard's PaymentMethodChart, which spans a whole year bucketed by month.
export function PaymentMethodDonutChart({ payments, height = "220px" }) {
  const { pixTotal, cardTotal } = useMemo(() => {
    let pix = 0;
    let card = 0;
    (payments || []).forEach(p => {
      if (p.status !== "paid") return;
      const val = (p.price_in_cents || 0) / 100;
      if (p.payment_method === "pix") pix += val;
      else card += val;
    });
    return { pixTotal: pix, cardTotal: card };
  }, [payments]);

  const total = pixTotal + cardTotal;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%",
    plugins: {
      legend: {
        position: "bottom",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 16, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: ctx => {
            const pct = total > 0 ? ((ctx.raw / total) * 100).toFixed(1) : 0;
            return ` ${ctx.label}: ${Number(ctx.raw).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} (${pct}%)`;
          },
        },
      },
    },
  };

  const data = {
    labels: ["PIX", "Cartão"],
    datasets: [
      {
        data: [pixTotal, cardTotal],
        backgroundColor: ["rgba(39,174,96,.8)", "rgba(41,128,185,.8)"],
        borderColor: ["#27ae60", "#2980b9"],
        borderWidth: 2,
        hoverOffset: 6,
      },
    ],
  };

  if (total === 0) {
    return (
      <div style={{ height, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontSize: 12, color: "#a0aec0" }}>Sem pagamentos confirmados no período</span>
      </div>
    );
  }

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Doughnut options={options} data={data} />
    </div>
  );
}
